import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const HighDetailedForYou = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_i_2517_721)">
          <path
            d="M19.0317 3.75372C19.2897 2.75343 20.7103 2.75343 20.9683 3.75372L23.9539 15.3276C24.0448 15.68 24.32 15.9552 24.6724 16.0461L36.2463 19.0317C37.2466 19.2897 37.2466 20.7103 36.2463 20.9683L24.6724 23.9539C24.32 24.0448 24.0448 24.32 23.9539 24.6724L20.9683 36.2463C20.7103 37.2466 19.2897 37.2466 19.0317 36.2463L16.0461 24.6724C15.9552 24.32 15.68 24.0448 15.3276 23.9539L3.75372 20.9683C2.75343 20.7103 2.75343 19.2897 3.75372 19.0317L15.3276 16.0461C15.68 15.9552 15.9552 15.68 16.0461 15.3276L19.0317 3.75372Z"
            fill="url(#paint0_linear_2517_721)"
          />
        </g>
        <g filter="url(#filter1_i_2517_721)">
          <path
            d="M33.8224 29.9006C34.3225 30.0296 34.3225 30.7399 33.8224 30.8689L31.563 31.4517C31.3868 31.4972 31.2492 31.6348 31.2037 31.811L30.6209 34.0704C30.4919 34.5706 29.7816 34.5706 29.6526 34.0704L29.0697 31.811C29.0243 31.6348 28.8867 31.4972 28.7105 31.4517L26.4511 30.8689C25.9509 30.7399 25.9509 30.0296 26.4511 29.9006L28.7105 29.3178C28.8867 29.2723 29.0243 29.1347 29.0697 28.9585L29.6526 26.6991C29.7816 26.199 30.4919 26.199 30.6209 26.6991L31.2037 28.9585C31.2492 29.1347 31.3868 29.2723 31.563 29.3178L33.8224 29.9006Z"
            fill="#FFA031"
          />
        </g>
        <g filter="url(#filter2_i_2517_721)">
          <path
            d="M13.6104 8.88597C14.1106 9.01498 14.1106 9.72525 13.6104 9.85427L10.3574 10.6934C10.1812 10.7389 10.0436 10.8765 9.99811 11.0527L9.15896 14.3058C9.02994 14.8059 8.31967 14.8059 8.19065 14.3058L7.3515 11.0527C7.30604 10.8765 7.16844 10.7389 6.99224 10.6934L3.73916 9.85427C3.23902 9.72525 3.23902 9.01498 3.73917 8.88596L6.99224 8.04681C7.16844 8.00135 7.30604 7.86376 7.3515 7.68755L8.19065 4.43448C8.31967 3.93433 9.02994 3.93433 9.15896 4.43448L9.99811 7.68755C10.0436 7.86376 10.1812 8.00135 10.3574 8.04681L13.6104 8.88597Z"
            fill="#FFA031"
          />
        </g>
        <rect
          width="4.13525"
          height="33.9658"
          transform="matrix(-1 0 0 1 20 3.02637)"
          fill="url(#paint1_linear_2517_721)"
          fillOpacity="0.3"
        />
        <rect
          x="3.01709"
          y="20.0093"
          width="4.13525"
          height="33.9658"
          transform="rotate(-90 3.01709 20.0093)"
          fill="url(#paint2_linear_2517_721)"
          fillOpacity="0.3"
        />
        <defs>
          <filter
            id="filter0_i_2517_721"
            x="3.00342"
            y="3.00342"
            width="33.9932"
            height="33.9932"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="0.5" dy="0.5" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2517_721" />
          </filter>
          <filter
            id="filter1_i_2517_721"
            x="26.0759"
            y="26.3242"
            width="8.12158"
            height="8.12109"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="0.5" dy="0.5" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2517_721" />
          </filter>
          <filter
            id="filter2_i_2517_721"
            x="3.36401"
            y="4.05957"
            width="10.6216"
            height="10.6211"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="0.5" dy="0.5" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2517_721" />
          </filter>
          <linearGradient
            id="paint0_linear_2517_721"
            x1="22.3109"
            y1="22.837"
            x2="17.336"
            y2="16.5529"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFA031" />
            <stop offset="1" stopColor="#FFD809" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2517_721"
            x1="4.13525"
            y1="16.9829"
            x2="0"
            y2="16.9829"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" stopOpacity="0" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2517_721"
            x1="7.15234"
            y1="36.9922"
            x2="3.01709"
            y2="36.9922"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" stopOpacity="0" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
        </defs>
      </svg>
    )
  },
)

export default HighDetailedForYou
